import React, { useEffect, useState, useRef } from "react";
import "./ncr.css";
import leftArrow from "../../assets/Images/left-arrow.png";
import rightArrow from "../../assets/Images/right-arrow.png";
import Filter from "../../assets/Icons/filter.png";
import Download from "../../assets/Icons/download.png";
import plusIcon from "../../assets/Icons/plus_icon.png";
import { PROJECT_API } from "../../services/apiCalls/projectApiCalls";
import { toast } from "react-toastify";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import Close from "../../assets/Images/close.png";
import PdfIcon from "../../assets/Icons/Pdf_Icon.png";
import DownloadIcon from "../../assets/Icons/Download_Icon.png";
import ExcelExport from "../../compnenets/commons/xls";

function SOP(props) {
  console.log(props);
  const [type, setType] = useState("list");
  const handleChangeTab = () => {
    setType("form");
  };
  const [currentPage, setCurrentPage] = useState(1);
  const [jobMethodologyData, setJobMethodologyData] = useState([]);
  const rowsPerPage = 10;
  const [sopData, setSopData] = useState([]);
  const totalPages = Math.ceil(sopData.length / rowsPerPage);
  const totalPagesJob = Math.ceil(jobMethodologyData.length / rowsPerPage);
  const [create, setCreate] = useState(false);
  const [jobMathodologyId, setJobMethodologyId] = useState("");
  const [jobDocumentname, setJobDocumentName] = useState("");
  const [jobFile, setJobFile] = useState("");

  const handleClick = (page) => {
    setCurrentPage(page);
  };
  const handleClickJob = (page) => {
    setCurrentPageJob(page);
  };

  const paginatedData = sopData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const handleRowClickJob = (job) => {
    setJobDocumentName(job.NameofDocument);
    setJobMethodologyId(job.JobMethodID);
    setJobFile(job.JobMethodology);
    setType("form");
    setCreate(true);
  };
  const [currentPageJob, setCurrentPageJob] = useState(1);
  const fetchJobMethodology = async () => {
    const payload = {
      UserID: state.user.user_id,
    };
    const response = await PROJECT_API.getJobMethodologyList(payload);
    if (response && response.Status === 200) {
      setJobMethodologyData(response.QualitySOPJobMethodologylist);
    }
  };

  const paginatedDataJob = jobMethodologyData.slice(
    (currentPageJob - 1) * rowsPerPage,
    currentPageJob * rowsPerPage
  );

  useEffect(() => {
    fetchJobMethodology();
    getSafetyStandards();
  }, []);
  const downloadFile = (fileUrl) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    console.log(fileUrl?.split("/").pop());
    link.setAttribute("download", fileUrl?.split("/").pop());
    // link.download = decodeURIComponent(fileUrl?.split('/').pop());
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const getSafetyStandards = async () => {
    try {
      const response = await PROJECT_API.getSOPList();
      if (response.Status === 200) {
        setSopData(response.Safety);
      } else {
        console.error("Failed get Quality Standards:", response.message);
      }
    } catch (error) {
      console.error("Error to get Quality Standards:", error);
    }
  };

  const handleJobFileChange = (event) => {
    const file = event.target.files[0];
    console.log(file, "file");
    if (file) {
      //  console.log("Selected file:", file);
      setJobFile(file);
    }
  };
  const handleJobmethodologySubmit = async () => {
    if (jobDocumentname.trim() === "" || !jobFile) {
      toast.error("Please fill in all fields!");
      return;
    }
    let response = { fileUrl: jobFile };
    if (typeof jobFile === "object") {
      response = await PROJECT_API.saveDocument(jobFile);
    }

    const usr = localStorage.getItem("state");
    const state = JSON.parse(usr);
    const payload = {
      JobMethodID: jobMathodologyId,
      ProjectID: props.project.Project_Id,
      UserID: state.user.user_id,
      ProjectName: props.project.Project_Name,
      JobMethodology: response.fileUrl,
      NameofDocument: jobDocumentname,
    };
    console.log(payload, "------");
    const res = await PROJECT_API.insertUpdateJobMethodology(payload);
    if (res && res.Status === 200) {
      toast.success("Job Methodology created Successfully!");
      fetchJobMethodology();
      setCreate(false);
      setJobMethodologyId("");
      setJobDocumentName("");
      setJobFile("");
    }
  };
  const onCloseModalFilter = () => {};
  const onCloseModalFilterJob = () => {};
  const [openFilter, setOpenFilter] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };
  const handleChangeJob = (e) => {
    const { name, value } = e.target;
    setFilterDataJob((prev) => ({ ...prev, [name]: value }));
  };
  const usr = localStorage.getItem("state");
  const state = JSON.parse(usr);
  const [openFilterJob, setOpenFilterJob] = useState(false);
  const [filterData, setFilterData] = useState({
    user_id: state?.user?.user_id,
    startDate: "",
    endDate: "",
    NameofDocument: "",
  });
  const [filterDataJob, setFilterDataJob] = useState({
    user_id: state?.user?.user_id,
    startDate: "",
    endDate: "",
    NameofDocument: "",
  });
  const handleFilterClick = async () => {
    setCurrentPage(1);
    const standardSop = await PROJECT_API.getSOPList(filterData);
    if (standardSop && standardSop.Safety?.length) {
      setSopData(standardSop.Safety);
    }
    setOpenFilter(false);
  };
  const handleFilterClickJob = async () => {
    setCurrentPageJob(1);
    const job = await PROJECT_API.getJobMethodologyList(filterDataJob);
    if (job && job.QualitySOPJobMethodologylist?.length) {
      setJobMethodologyData(job.QualitySOPJobMethodologylist);
    }
    setOpenFilterJob(false);
  };
  return (
    <>
      <Modal open={openFilter} onClose={onCloseModalFilter} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Quality Standard Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => setOpenFilter(false)}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <label className="filter-label">Start date</label>
                  <input
                    type="date"
                    name="startDate"
                    value={filterData.startDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">End date</label>
                  <input
                    type="date"
                    name="endDate"
                    value={filterData.endDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Document Name</label>
                  <input
                    type="text"
                    name="NameofDocument"
                    value={filterData.NameofDocument}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center mt-4 pb-4">
          <button
            className="btn btn-primary"
            onClick={() => handleFilterClick(filterData)}
          >
            Filter
          </button>
        </div>
      </Modal>
      <div
        className="select-tab d-flex align-items-center"
        style={{ marginTop: "10px" }}
      >
        <div className="d-flex align-items-center flex-grow-1">
          <div
            className={`tab ${type === "list" ? "tab-active" : ""}`}
            onClick={() => setType("list")}
          >
            Standard SOP
          </div>
          <div
            className={`tab ${type === "form" ? "tab-active" : ""}`}
            onClick={() => handleChangeTab()}
          >
            Job Methodology
          </div>
        </div>

        {type === "list" ? (
          <>
            <div className="d-flex justify-content-end align-items-center">
              <div className="download-icon">
                <ExcelExport
                  data={sopData?.map((val) => {
                    return {
                      "Document Name": val.DocumentName,
                      "Standard SOP": val.StandardSOPSafety,
                      "Created By": val.CreatedBy,
                      "Created Date": val.CreatedDate,
                    };
                  })}
                  fileName="Standard SOP List"
                  sheet="Standard SOP List"
                />
              </div>
              <div className="filter-icon mx-2 my-auto">
                <img
                  className=""
                  onClick={() => {
                    setOpenFilter(true);
                  }}
                  src={Filter}
                  width={20}
                />
              </div>
            </div>
          </>
        ) : (
          <>
            <Modal open={openFilterJob} onClose={onCloseModalFilterJob} center>
              <div className="d-flex justify-content-between">
                <div>
                  <span className="resorces">
                    Quality Job Methodology Filter
                  </span>
                </div>
                <div>
                  <img
                    src={Close}
                    width={20}
                    onClick={() => setOpenFilterJob(false)}
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="card mt-0 card-bd-none">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-6">
                        <label className="filter-label">Start date</label>
                        <input
                          type="date"
                          name="startDate"
                          value={filterDataJob.startDate}
                          onChange={handleChangeJob}
                          className="form-control shadow-none"
                        />
                      </div>
                      <div className="col-6">
                        <label className="filter-label">End date</label>
                        <input
                          type="date"
                          name="endDate"
                          value={filterDataJob.endDate}
                          onChange={handleChangeJob}
                          className="form-control shadow-none"
                        />
                      </div>
                    </div>

                    <div className="row mt-1">
                      <div className="col-6">
                        <label className="filter-label">Document Name</label>
                        <input
                          type="text"
                          name="NameofDocument"
                          value={filterDataJob.NameofDocument}
                          onChange={handleChangeJob}
                          className="form-control shadow-none"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-center mt-4 pb-4">
                <button
                  className="btn btn-primary"
                  onClick={() => handleFilterClickJob(filterDataJob)}
                >
                  Filter
                </button>
              </div>
            </Modal>
            <div className="d-flex justify-content-end align-items-center">
              {!create && (
                <>
                  <div className="download-icon">
                    <ExcelExport
                      data={jobMethodologyData?.map((val) => {
                        return {
                          "Project Name": val.ProjectName,
                          "Document Name": val.DocumentName,
                          "Job Methodology": val.JobMethodology,
                          "User Id": val.UserID,
                        };
                      })}
                      fileName="Jobmethodology List"
                      sheet="Jobmethodology List"
                    />
                  </div>
                  <div className="filter-icon mx-2 my-auto">
                    <img
                      className=""
                      onClick={() => {
                        setOpenFilterJob(true);
                      }}
                      src={Filter}
                      width={20}
                    />
                  </div>
                  <div className="my-auto">
                    <span
                      style={{
                        cursor: "pointer",
                        fontSize: 12,
                        fontWeight: 500,
                        background: "#8add79f7",
                        padding: 5,
                        borderRadius: 12,
                      }}
                      onClick={() => {
                        fetchJobMethodology();
                      }}
                    >
                      Clear filters
                    </span>
                  </div>
                </>
              )}

              <div
                className="create-button"
                style={{
                  ...(!create ? { marginRight: "160px" } : {}),
                }}
                onClick={() => setCreate(true)}
              >
                <img
                  src={plusIcon}
                  alt="plus"
                  height="15"
                  width="15"
                  style={{ marginRight: "5px" }}
                />
                <span style={{ color: "white", fontSize: "14px" }}>
                  Add Job Methodology
                </span>
              </div>
            </div>
          </>
        )}
      </div>
      {type === "form" ? (
        create === false ? (
          <>
            <div
              className="table-container"
              style={{
                marginLeft: "0px",
                marginRight: "0px",
                marginTop: "10px",
              }}
            >
              <table className="custom-table">
                <thead className="table-header">
                  <tr>
                    <th>Sr No</th>
                    <th>Project Name</th>
                    <th>Name of Document</th>
                    <th>Job Methodology </th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedDataJob.map((ncr, index) => (
                    <tr
                      key={ncr.JobMethodID}
                      onClick={() => handleRowClickJob(ncr)}
                    >
                      <td>{index + 1 + (currentPageJob - 1) * 10}</td>
                      <td>{ncr.ProjectName}</td>
                      <td>{ncr.NameofDocument}</td>
                      <td>
                        <img
                          src={PdfIcon}
                          alt="PDF Icon"
                          style={{ width: "16px", marginRight: "8px" }}
                        />
                        {decodeURIComponent(
                          ncr.JobMethodology.split("/").pop()
                        )}
                        <img
                          src={DownloadIcon}
                          alt="Download Icon"
                          style={{
                            width: "16px",
                            marginLeft: "8px",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            downloadFile(ncr.JobMethodology);
                          }}
                        />
                      </td>
                      <td>{ncr.CreatedOn}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div
                className="pagination"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px 15px",
                }}
              >
                <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                  Showing{" "}
                  {Math.min(
                    (currentPageJob - 1) * rowsPerPage + 1,
                    jobMethodologyData.length
                  )}
                  to{" "}
                  {Math.min(
                    currentPageJob * rowsPerPage,
                    jobMethodologyData.length
                  )}{" "}
                  of {jobMethodologyData.length} entries
                </div>

                <div
                  className="pagination-buttons"
                  style={{
                    fontSize: "14px",
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%",
                    gap: "5px",
                  }}
                >
                  <button
                    onClick={() =>
                      handleClickJob(Math.max(1, currentPageJob - 1))
                    }
                    disabled={currentPageJob === 1}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: currentPageJob === 1 ? "not-allowed" : "pointer",
                    }}
                  >
                    <img
                      src={leftArrow}
                      alt="Previous"
                      height="10px"
                      width="10px"
                      style={{ opacity: currentPageJob === 1 ? 0.5 : 1 }}
                    />
                  </button>

                  {[...Array(totalPagesJob)].map((_, i) => (
                    <button
                      key={i}
                      onClick={() => handleClickJob(i + 1)}
                      style={{
                        background:
                          currentPageJob === i + 1 ? "#00B69B" : "transparent",
                        color: currentPageJob === i + 1 ? "#fff" : "#000",
                        border: "none",
                        borderRadius: "50%",
                        width: "30px",
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      {i + 1}
                    </button>
                  ))}

                  <button
                    onClick={() =>
                      handleClickJob(
                        Math.min(totalPagesJob, currentPageJob + 1)
                      )
                    }
                    disabled={currentPageJob === totalPagesJob}
                    style={{
                      background: "none",
                      border: "none",
                      cursor:
                        currentPageJob === totalPagesJob
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    <img
                      src={rightArrow}
                      alt="Next"
                      height="10px"
                      width="10px"
                      style={{
                        opacity: currentPageJob === totalPagesJob ? 0.5 : 1,
                      }}
                    />
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="card p-3 mt-2">
              <div className="d-flex">
                {jobMathodologyId && (
                  <div className="d-flex flex-column">
                    <label className="input-label" htmlFor="document_id">
                      Document ID
                    </label>
                    <input
                      className="input-style"
                      type="text"
                      name="document_id"
                      id="document_id"
                      value={jobMathodologyId}
                      disabled
                    />
                  </div>
                )}
                <div
                  className="d-flex flex-column"
                  style={{
                    ...(jobMathodologyId ? { marginLeft: "30px" } : {}),
                  }}
                >
                  <label className="input-label" htmlFor="project_name">
                    Project Name
                  </label>
                  <input
                    className="input-style"
                    type="text"
                    name="project_name"
                    id="project_name"
                    value={props.project.Project_Name}
                    disabled
                  />
                </div>
                <div
                  className="d-flex flex-column"
                  style={{ marginLeft: "30px" }}
                >
                  <label className="input-label" htmlFor="document_name">
                    Document Name
                  </label>
                  <input
                    className="input-style"
                    type="text"
                    name="document_name"
                    id="document_name"
                    value={jobDocumentname}
                    onChange={(e) => setJobDocumentName(e.target.value)}
                    placeholder="Enter document name"
                    autoComplete="off"
                  />
                </div>

                <div
                  className="d-flex flex-column"
                  style={{ marginLeft: "30px" }}
                >
                  <label className="input-label" htmlFor="job_methodology">
                    Job Methodology
                  </label>
                  <input
                    className="input-style"
                    type="file"
                    name="job_methodology"
                    id="job_methodology"
                    onChange={handleJobFileChange}
                  />
                </div>
              </div>
              <div className="action-div">
                <div className="button-div">
                  <button
                    className="btn btn-submit"
                    onClick={handleJobmethodologySubmit}
                  >
                    Submit
                  </button>
                  <button
                    className="btn btn-cancel"
                    onClick={() => {
                      setJobMethodologyId("");
                      setJobDocumentName("");
                      setJobFile("");
                      setCreate(false);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </>
        )
      ) : (
        <>
          {/* <div className="card p-4 mt-3">List</div> */}
          <div
            className="table-container"
            style={{
              marginLeft: "0px",
              marginRight: "0px",
              marginTop: "10px",
            }}
          >
            <table className="custom-table">
              <thead className="table-header">
                <tr>
                  <th>Sr No</th>
                  <th>Document Name</th>
                  <th>StandardSOP</th>
                  <th>Created Date</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((safetyStandards, index) => (
                  <tr
                    key={safetyStandards.ID}
                    onClick={() => {
                      // handleRowClick(
                      //   safetyStandards.ID,
                      //   safetyStandards.DocumentName,
                      //   safetyStandards.StandardSOPSafety
                      // );
                    }}
                  >
                    <td>{index + 1 + (currentPage - 1) * 10}</td>
                    <td>{safetyStandards.DocumentName}</td>
                    <td>
                      <img
                        src={PdfIcon}
                        alt="PDF Icon"
                        style={{ width: "16px", marginRight: "8px" }}
                      />
                      {decodeURIComponent(
                        safetyStandards.StandardSOPSafety.split("/").pop()
                      )}
                      <img
                        src={DownloadIcon}
                        alt="Download Icon"
                        style={{
                          width: "16px",
                          marginLeft: "8px",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          downloadFile(safetyStandards.StandardSOPSafety);
                        }}
                      />
                    </td>
                    <td>
                      {new Date(
                        safetyStandards.CreatedDate
                      ).toLocaleDateString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div
              className="pagination"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 15px",
              }}
            >
              <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                Showing{" "}
                {Math.min((currentPage - 1) * rowsPerPage + 1, sopData.length)}
                to {Math.min(currentPage * rowsPerPage, sopData.length)} of{" "}
                {sopData.length} entries
              </div>

              <div
                className="pagination-buttons"
                style={{
                  fontSize: "14px",
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                  gap: "5px",
                }}
              >
                <button
                  onClick={() => handleClick(Math.max(1, currentPage - 1))}
                  disabled={currentPage === 1}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  }}
                >
                  <img
                    src={leftArrow}
                    alt="Previous"
                    height="10px"
                    width="10px"
                    style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
                  />
                </button>

                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i}
                    onClick={() => handleClick(i + 1)}
                    style={{
                      background:
                        currentPage === i + 1 ? "#00B69B" : "transparent",
                      color: currentPage === i + 1 ? "#fff" : "#000",
                      border: "none",
                      borderRadius: "50%",
                      width: "30px",
                      height: "30px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                  >
                    {i + 1}
                  </button>
                ))}

                <button
                  onClick={() =>
                    handleClick(Math.min(totalPages, currentPage + 1))
                  }
                  disabled={currentPage === totalPages}
                  style={{
                    background: "none",
                    border: "none",
                    cursor:
                      currentPage === totalPages ? "not-allowed" : "pointer",
                  }}
                >
                  <img
                    src={rightArrow}
                    alt="Next"
                    height="10px"
                    width="10px"
                    style={{
                      opacity: currentPage === totalPages ? 0.5 : 1,
                    }}
                  />
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default SOP;
